<div class="sticker" *ngIf="hasLabel">
  {{ label.name }}
</div>
